"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from "@saridana-core/react-ui-kit";
import { TProduct } from "@shared/types";
import { CalculatedRateCalculatorForm } from "./calculated-rate-calculator-form";
import { FixedRateCalculatorForm } from "./fixed-rate-calculator-form";
export function ProductCalculatorForm(t0) {
  const $ = _c(4);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product) {
    t1 = () => {
      switch (product.calculatorType) {
        case "fixedRate":
        default:
          {
            return <FixedRateCalculatorForm product={product} />;
          }
        case "calculatedRate":
          {
            return <CalculatedRateCalculatorForm product={product} />;
          }
      }
    };
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getForm = t1;
  let t2;
  if ($[2] !== getForm) {
    t2 = <Card className="w-full"><CardContent className="h-auto px-6 py-8 md:px-9 md:py-10">{getForm()}</CardContent></Card>;
    $[2] = getForm;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}